import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import tenant from '../sub-projects/tenant/reducers/project';
import app from './app';
import authentication from './authentication';

const rootReducer = combineReducers({
  app: persistReducer({
    key: 'app',
    storage,
  }, app),
  authentication: persistReducer({
    key: 'authentication',
    storage,
  }, authentication),
  tenant: persistReducer({
    key: 'tenant',
    storage,
  }, tenant),
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts